

export const workImpactTypes = {
    noInformation:"NoInformation",
    possible:"Possible",
    difficult:"Difficult",
    impossible:"Impossible"
};